import { useMemo } from 'react';
import { FormControl, Checkbox, FormControlLabel, } from '@material-ui/core'
import { shouldBeLocked } from '../utils/Roles'

const CheckboxWithLabel = ({ id, formStyle, labelStyle, checked = false, onChange, stateName, title, disabled = undefined, userRoles, ...props }) => {
  const memoizedLocked = useMemo(() => shouldBeLocked(disabled, props?.canEdit, userRoles), [disabled, props?.canEdit, userRoles]);

  return (
    <FormControl className={formStyle}>
      <FormControlLabel
        control={
          <Checkbox
            id={id}
            disabled={memoizedLocked}
            checked={checked ?? false}
            onChange={onChange}
            value={stateName}
            color="primary"
            data-cy={title + "-checkbox"}
            inputProps={{ "data-cy": title + "-checkbox-input" }}
          />
        }
        label={title}
        data-cy={title + "-label"}
        className={labelStyle}
      />
    </FormControl>
  );
}

export default CheckboxWithLabel;